import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Root from 'containers/Root';
import GlobalStyle from 'styles/GlobalStyle';
import theme from 'styles/themes';
import { ReactQueryCacheProvider } from 'react-query';
import { queryCache } from 'data/cache';
import { AuthProvider } from 'data/context/AuthContext';
import ErrorBoundary from 'containers/Common/ErrorBoundary';
import { ReactQueryDevtools } from 'react-query-devtools';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Helmet } from 'react-helmet';
import GoogleAuthContextProvider from 'data/context/GoogleAuth';
import { InitialUrlProvider } from 'data/context/InitialUrlContext';

const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
let stripePromise: Promise<Stripe | null>;
if (stripePublicKey) {
  stripePromise = loadStripe(stripePublicKey);
}

const App: FC = () => (
  <ReactQueryCacheProvider queryCache={queryCache}>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ErrorBoundary>
        <BrowserRouter>
          <GoogleAuthContextProvider>
            <AuthProvider>
              <Elements stripe={stripePromise}>
                <InitialUrlProvider>
                  <Root />
                </InitialUrlProvider>
              </Elements>
            </AuthProvider>
          </GoogleAuthContextProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </ReactQueryCacheProvider>
);

export default App;
